export const ME_IS_FETCHING = 'ME_IS_FETCHING';
export const ME_GET_SUCCESS = 'ME_GET_SUCCESS';
export const ME_GET_ERROR = 'ME_GET_ERROR';
